package ui.app.assign.detail.wheel

import androidx.compose.foundation.Canvas
import androidx.compose.foundation.background
import androidx.compose.foundation.layout.*
import androidx.compose.runtime.Composable
import androidx.compose.ui.Modifier
import androidx.compose.ui.geometry.Offset
import androidx.compose.ui.geometry.Size
import androidx.compose.ui.graphics.Color
import androidx.compose.ui.graphics.FilterQuality
import androidx.compose.ui.graphics.ImageBitmap
import androidx.compose.ui.graphics.Path
import androidx.compose.ui.graphics.drawscope.clipRect
import androidx.compose.ui.graphics.drawscope.translate
import androidx.compose.ui.layout.ContentScale
import androidx.compose.ui.unit.Dp
import androidx.compose.ui.unit.IntOffset
import androidx.compose.ui.unit.IntSize
import androidx.compose.ui.unit.dp
import apps.App
import org.ssoft.common.ui.wheel.AppWheelFactory.buildTrianglePath
import ui.app.assign.detail.wheel.editor.AppEditorWheelScope
import ui.widget.LazyImage
import kotlin.math.roundToInt


@Composable
fun AppEditorWheelScope.AppWheelRendererGame(
    nnvl: AppEditorWheelScope.Wrapper,
    modifier: Modifier,
    padding: Dp = 16.dp
) {
    Box(
        modifier.padding(horizontal = padding)
            .padding(padding)
            .let {
                if (nnvl.orientation.state == App.Wheel.Theme.ORIENTATION_LAND) {
                    it.fillMaxWidth()
                        .aspectRatio(16F / 9F, false)
                } else {
                    it.fillMaxHeight()
                        .aspectRatio(9F / 16F, true)
                }
            }

    ) {
        AppWheelRendererGame(
            modifier = Modifier.fillMaxSize(),
            bgImageId = nnvl.themeBgGame.state,
            bgColor = nnvl.themeBgColor.state,
            wheelImage = vm.wheelImage,
            wheelScale = nnvl.themeWheelScale.state,
            wheelX = nnvl.themeWheelPosX.state,
            wheelY = nnvl.themeWheelPosY.state
        )
    }
}

@Composable
fun AppWheelScope.AppWheelRendererGame(
    modifier: Modifier,
    bgImageId: Long,
    bgColor: Color,
    wheelImage: ImageBitmap?,
    wheelScale: Float,
    wheelX: Float,
    wheelY: Float,
) {
    Box(
        modifier.background(bgColor)
    ) {
        if (bgImageId > -999) {
            LazyImage(
                id = bgImageId,
                modifier = Modifier.fillMaxSize(),
                contentScale = ContentScale.FillBounds
            )
        }

        Canvas(Modifier.fillMaxSize()) {
            clipRect {


                wheelImage?.also {
                    val wheelSize = ((wheelScale) * minOf(
                        size.width,
                        size.height
                    ))

                    clipRect {


                        translate(
                            ((size.width * wheelX) - (wheelSize / 2F)),
                            ((size.height * wheelY) - (wheelSize / 2F))
                        ) {
                            drawImage(
                                image = it,
                                srcOffset = IntOffset.Zero,
                                srcSize = IntSize(it.width, it.height),
                                dstOffset = IntOffset.Zero,
                                dstSize = IntSize(
                                    width = wheelSize.roundToInt(),
                                    height = wheelSize.roundToInt()
                                ),
                                filterQuality = FilterQuality.High
                            )
                        }
                    }
                    drawPath(
                        path = buildTrianglePath(
                            wheelScale = wheelScale,
                            wheelX = wheelX,
                            wheelY = wheelY,
                            screen = size
                        ),
                        color = Color.Red
                    )
                }
            }
        }
    }
}
